'use client';
import React, { FC } from 'react';
import { motion, useInView } from 'framer-motion';

interface IProps {
  title: string;
  description: string;
  items: { title: string; description: string }[];
  footerText: string;
}

export const ContentWhy: FC<IProps> = ({
  title,
  description,
  items,
  footerText,
}) => {
  // Создаем реф для проверки видимости
  const sectionRef = React.useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, { once: true }); // Проверяем, находится ли элемент в области видимости

  return (
    <div ref={sectionRef}>
      <motion.h3
        className="mb-6 text-left text-4xl font-semibold"
        initial={{ opacity: 0, y: 10 }} // Начальное состояние
        animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при видимости
        exit={{ opacity: 0, y: 10 }} // Выходное состояние
        transition={{ duration: 0.3 }} // Длительность анимации
      >
        {title}
      </motion.h3>
      <motion.p
        className="description-with-links mb-10 text-left text-lg font-normal"
        initial={{ opacity: 0, y: 10 }} // Начальное состояние
        animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при видимости
        exit={{ opacity: 0, y: 10 }} // Выходное состояние
        transition={{ duration: 0.3 }} // Длительность анимации
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <ul className="mb-13">
        {items.map((item) => (
          <motion.li
            className="mb-6 text-left"
            key={item.title}
            initial={{ opacity: 0, y: 10 }} // Начальное состояние
            animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при видимости
            exit={{ opacity: 0, y: 10 }} // Выходное состояние
            transition={{ duration: 0.3 }} // Длительность анимации
          >
            <span className="text-left font-semibold">{item.title} </span>
            <span className="text-left font-normal">{item.description}</span>
          </motion.li>
        ))}
      </ul>
      <motion.p
        className="description-with-links text-left font-medium"
        initial={{ opacity: 0, y: 10 }} // Начальное состояние
        animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при видимости
        exit={{ opacity: 0, y: 10 }} // Выходное состояние
        transition={{ duration: 0.3 }} // Длительность анимации
        dangerouslySetInnerHTML={{ __html: footerText }}
      />
    </div>
  );
};
